import bookIcon from 'assets/icons/book-white.svg';
import { Img } from 'shared/ui/imgStyledComponent';

export const BookWhiteIcon = () => {
	return <Img role="image" src={bookIcon} />;
};
